import { render } from "./PageJadwalKelasPercobaan.vue?vue&type=template&id=71c9f551"
import script from "./PageJadwalKelasPercobaan.vue?vue&type=script&lang=js"
export * from "./PageJadwalKelasPercobaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__